import {
  LIST_BRANCH_PACKAGE_CATEGORY_REQUEST,
  LIST_BRANCH_PACKAGE_CATEGORY_SUCCESS,
  LIST_BRANCH_PACKAGE_CATEGORY_FAIL,
  PATCH_BRANCH_PACKAGE_CATEGORY_REQUEST,
  PATCH_BRANCH_PACKAGE_CATEGORY_SUCCESS,
  PATCH_BRANCH_PACKAGE_CATEGORY_FAIL,
  DETAIL_BRANCH_PACKAGE_CATEGORY_REQUEST,
  DETAIL_BRANCH_PACKAGE_CATEGORY_SUCCESS,
  DETAIL_BRANCH_PACKAGE_CATEGORY_FAIL,
  LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_REQUEST,
  LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_SUCCESS,
  LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_FAIL,
  LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_ITEM_REQUEST,
  LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_ITEM_SUCCESS,
  LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_ITEM_FAIL,
  LIST_BRANCH_PACKAGE_CATEGORY_ADDITIONAL_INFO_REQUEST,
  LIST_BRANCH_PACKAGE_CATEGORY_ADDITIONAL_INFO_SUCCESS,
  LIST_BRANCH_PACKAGE_CATEGORY_ADDITIONAL_INFO_FAIL,
  LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_REQUEST,
  LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_SUCCESS,
  LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_FAIL,
  DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_REQUEST,
  DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_SUCCESS,
  DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_FAIL,
  LIST_DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_REQUEST,
  LIST_DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_SUCCESS,
  LIST_DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_FAIL
} from '../../constants/branch-package-category'

const initialState = {
  loadingPackagePriceCategory: false,
  loadingDetailPackagePriceCategory: false,
  loadingPatchPackagePriceCategory: false,
  loadingPackageService: false,
  loadingPackageServiceItem: false,
  loadingAdditionalInfo: false,
  loadingImport: false,
  loadingDetailImport: false,
  loadingListDetailImport: false,
  PackagePriceCategorys: [],
  AdditionalInfo: [],
  ImportList: [],
  detailPackagePriceImport: {},
  listDetailPackagePriceImport: [],
  PackagePriceCategory: {},
  PackageService: [],
  PackageServiceItem: [],
  error: null,
  pageableDetail: {},
  pageable: {
    page: 1,
    size: 10
  }
}

const packagePriceCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_BRANCH_PACKAGE_CATEGORY_REQUEST:
      return { ...state, loadingPackagePriceCategory: true }
    case LIST_BRANCH_PACKAGE_CATEGORY_SUCCESS:
      return {
        ...state,
        loadingPackagePriceCategory: false,
        PackagePriceCategorys: action.payload,
        pageable: action.pageable
      }
    case LIST_BRANCH_PACKAGE_CATEGORY_FAIL:
      return {
        ...state,
        loadingPackagePriceCategory: false,
        error: action.payload
      }
    case LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_REQUEST:
      return { ...state, loadingPackageService: true }
    case LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_SUCCESS:
      return {
        ...state,
        loadingPackageService: false,
        PackageService: action.payload,
        pageable: action.pageable
      }
    case LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_FAIL:
      return {
        ...state,
        loadingPackageService: false,
        error: action.payload
      }
    case LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_ITEM_REQUEST:
      return { ...state, loadingPackageServiceItem: true }
    case LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_ITEM_SUCCESS:
      return {
        ...state,
        loadingPackageServiceItem: false,
        PackageServiceItem: action.payload
      }
    case LIST_BRANCH_PACKAGE_CATEGORY_SERVICE_ITEM_FAIL:
      return {
        ...state,
        loadingPackageServiceItem: false,
        error: action.payload
      }
    case LIST_BRANCH_PACKAGE_CATEGORY_ADDITIONAL_INFO_REQUEST:
      return { ...state, loadingAdditionalInfo: true, AdditionalInfo: [] }
    case LIST_BRANCH_PACKAGE_CATEGORY_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        loadingAdditionalInfo: false,
        AdditionalInfo: action.payload
      }
    case LIST_BRANCH_PACKAGE_CATEGORY_ADDITIONAL_INFO_FAIL:
      return {
        ...state,
        loadingAdditionalInfo: false,
        AdditionalInfo: [],
        error: action.payload
      }
    case PATCH_BRANCH_PACKAGE_CATEGORY_REQUEST:
      return { ...state, loadingPatchPackagePriceCategory: true }
    case PATCH_BRANCH_PACKAGE_CATEGORY_SUCCESS:
      return {
        ...state,
        loadingPatchPackagePriceCategory: false,
        PackagePriceCategoryDetail: action.payload
      }
    case PATCH_BRANCH_PACKAGE_CATEGORY_FAIL:
      return {
        ...state,
        loadingPatchPackagePriceCategory: false,
        error: action.payload
      }
    case DETAIL_BRANCH_PACKAGE_CATEGORY_REQUEST:
      return {
        ...state,
        loadingDetailPackagePriceCategory: true,
        error: null,
        PackagePriceCategory: {}
      }
    case DETAIL_BRANCH_PACKAGE_CATEGORY_SUCCESS:
      return {
        ...state,
        loadingDetailPackagePriceCategory: false,
        PackagePriceCategory: action.payload,
        error: null
      }
    case DETAIL_BRANCH_PACKAGE_CATEGORY_FAIL:
      return {
        ...state,
        loadingDetailPackagePriceCategory: false,
        error: action.payload
      }
    case LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_REQUEST:
      return {
        ...state,
        loadingImport: true,
        error: null,
        ImportList: []
      }
    case LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_SUCCESS:
      return {
        ...state,
        loadingImport: false,
        importList: action.payload,
        pageable: action.pageable,
        error: null
      }
    case LIST_BRANCH_PACKAGE_CATEGORY_IMPORT_FAIL:
      return {
        ...state,
        loadingImport: false,
        error: action.payload
      }
    case DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_REQUEST:
      return {
        ...state,
        loadingDetailImport: true,
        error: null,
        detailPackagePriceImport: {}
      }
    case DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_SUCCESS:
      return {
        ...state,
        loadingDetailImport: false,
        detailPackagePriceImport: action.payload,
        error: null
      }
    case DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_FAIL:
      return {
        ...state,
        loadingDetailImport: false,
        error: action.payload
      }
    case LIST_DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_REQUEST:
      return {
        ...state,
        loadingListDetailImport: true,
        error: null,
        listDetailPackagePriceImport: []
      }
    case LIST_DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_SUCCESS:
      return {
        ...state,
        loadingListDetailImport: false,
        listDetailPackagePriceImport: action.payload,
        pageableDetail: action.pageable,
        error: null
      }
    case LIST_DETAIL_BRANCH_PACKAGE_CATEGORY_IMPORT_FAIL:
      return {
        ...state,
        loadingListDetailImport: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default packagePriceCategoryReducer
